export const faqData = [
    {
        id: 1,
        question: 'Як проходить навчання на курсі "Оптимальний"?',
        answer: 'Курс комбінований. Кожен тиждень нова тема, яку розглядаємо впродовж трьох уроків – два з яких в записі, третій онлайн – не лекція, а повноцінний урок в міні групі 4-5 учнів. До кожного уроку є практична частина у вигляді проходження тестів у форматі НМТ та їх відеопояснення. '
    },
    {
        id: 2,
        question: 'Чи вивчаємо найскладнішу тему – рівняння з параметром?',
        answer: 'Так. Ця тема розглядається двічі. Спочатку при вивченні блоку «Рівняння та нерівності» і другий раз додатковими уроками (які входять у вартість) наприкінці курсу.'
    },
    {
        id: 3,
        question: 'Чи є можливість проходження пробного НМТ?',
        answer: 'Так. На курсі є понад 20 симуляцій НМТ, які можна проходити декілька раз.'
    },
    {
        id: 4,
        question: 'Чи потрібно додатково придбати посібники та підручники для навчання?',
        answer: 'Ні. Все, що потрібно для роботи входить у вартість курсу. '
    },
    {
        id: 5,
        question: 'Якщо рівень знань дуже низький, чи підійде мані курс?',
        answer: 'Так. Групи формуються по рівню знань і згідно встановленого рівня проводиться навчання. Крім того вивчення матеріалу розпочинаємо з базових питань.'
    }
];